// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__ErODX","log":"ModalInventoryLogs_log__o2TZy","date":"ModalInventoryLogs_date__16Z8x","userName":"ModalInventoryLogs_userName__cEF1V"};